'use client';

import createClient from '@sanity/client';
import {
  SANITY_API_VERSION,
  SANITY_DATASET,
  SANITY_PROJECT_ID,
} from 'config/sanity-env';
import { THEME_LIGHT } from 'constants/themes';
import SanityClientContext from 'contexts/sanity-client';
import { ThemeProvider } from 'lib/next-themes';
import type { PropsWithChildren, ReactElement } from 'react';
import { useMemo } from 'react';

function Providers({ children }: PropsWithChildren): ReactElement {
  const sanityClient = useMemo(() => {
    return createClient({
      projectId: SANITY_PROJECT_ID,
      dataset: SANITY_DATASET,
      apiVersion: SANITY_API_VERSION,
      useCdn: true,
    });
  }, []);

  return (
    <ThemeProvider
      attribute="class"
      enableSystem={false}
      themes={[THEME_LIGHT]}
      value={{ dark: 'dark-theme' }} // Re-map the dark CSS class to `dark-theme` which radix-color uses
    >
      <SanityClientContext.Provider value={sanityClient}>
        {children}
      </SanityClientContext.Provider>
    </ThemeProvider>
  );
}

export default Providers;
